'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAccount = exports.checkAuthorization = exports.logout = exports.login = exports.signup = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var signup = exports.signup = function signup(properties) {
  return (0, _callApi2.default)('POST', '/signup', properties, 'application/json');
};
var login = exports.login = function login(username, password, token) {
  return (0, _callApi2.default)('POST', '/authorize', { username: username, password: password, token: token }, 'application/json');
};
var logout = exports.logout = function logout(username, token) {
  return (0, _callApi2.default)('POST', '/logout', { username: username, token: token }, 'application/json');
};
var checkAuthorization = exports.checkAuthorization = function checkAuthorization(username, token) {
  return (0, _callApi2.default)('POST', '/authorized/' + token, { username: username }, 'application/json');
};
var validateAccount = exports.validateAccount = function validateAccount(number, username) {
  return (0, _callApi2.default)('POST', /validate-account/, { number: number, username: username }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/session-authorization.js
// module id = 743
// module chunks = 0